import { routeNames } from "@/constants/routes.js"

import { useGlobalStore } from "@/stores/global.js"
import { useSessionStore } from "@/stores/session.js"

import i18n from "@/plugins/i18n.js"

export const getModulesDisplayInfo = () => {
  const sessionStore = useSessionStore()

  const roles = sessionStore.userInfo?.roles || []

  const isUserAdminVisitorOrWatcher = roles.includes("PORTADMIN") || roles.includes("VISITOR") || roles.includes("WATCHER")

  return [
    {
      key: "main",
      title: i18n.global.t("MODULES_GENERAL"),
      adminPanelRoute: {
        name: routeNames.mainAdminPanel
      },
      settingsOnly: true,
      v3: true
    },
    {
      key: "mwApplicationsRequests",
      title: i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_MW"),
      description: i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_DESCRIPTION_MW"),
      urlPath: "mw-applications-requests",
      requiredRequestSystems: ["MW"],
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR"],
      v3: true,
      route: {
        name: routeNames.mwApplicationsRequestsMain
      },
      adminPanelRoute: {
        name: routeNames.mwApplicationsRequestsAdminPanel
      }
    },
    {
      key: "mwExisting",
      title: i18n.global.t("MODULES_EXISTING_MICROWAVE_LINKS"),
      description: i18n.global.t("MODULES_EXISTING_MICROWAVE_LINKS_DESCRIPTION"),
      urlPath: "mw-existing",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true,
      route: {
        name: routeNames.mwExistingMain
      },
      adminPanelRoute: {
        name: routeNames.mwExistingAdminPanel
      }
    },
    {
      key: "mwParity",
      title: i18n.global.t("MODULES_MW_PARITY"),
      description: i18n.global.t("MODULES_MW_PARITY_DESCRIPTION"),
      urlPath: "mw-parity",
      requiredRequestSystems: ["MW"],
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR"],
      v3: true,
      route: {
        name: routeNames.mwParityMain
      },
      adminPanelRoute: {
        name: routeNames.mwParityAdminPanel
      },
      requlatorAccessValidation: true,
      accessibleByAdmin: true
    },
    {
      key: "mwDeploymentSimulation",
      title: i18n.global.t("MODULES_MW_DEPLOYMENT_SIMULATION"),
      description: i18n.global.t("MODULES_MW_DEPLOYMENT_SIMULATION_DESCRIPTION"),
      urlPath: "mw-deployment-simulation",
      requlatorAccessValidation: true,
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true,
      route: {
        name: routeNames.mwDeploymentSimulationMain
      },
      adminPanelRoute: {
        name: routeNames.mwDeploymentSimulationAdminPanel
      }
    },
    {
      key: "esApplicationsRequests",
      title: i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_ES"),
      description: i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_DESCRIPTION_ES"),
      urlPath: "es-applications-requests",
      requiredRequestSystems: ["ES"],
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR"],
      v3: true,
      route: {
        name: routeNames.esApplicationsRequestsMain
      },
      adminPanelRoute: {
        name: routeNames.esApplicationsRequestsAdminPanel
      }
    },
    {
      key: "mobApplicationsRequests",
      title: i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_MOB"),
      description: i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_DESCRIPTION_MOB"),
      urlPath: "mob-applications-requests",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"]
    },
    {
      key: "bctApplicationsRequests",
      title: i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_BCT"),
      description: i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_DESCRIPTION_BCT"),
      urlPath: "bct-applications-requests",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true
    },
    {
      key: "esExisting",
      title: i18n.global.t("MODULES_EXISTING_EARTH_STATIONS"),
      description: i18n.global.t("MODULES_EXISTING_EARTH_STATIONS_DESCRIPTION"),
      urlPath: "es-existing",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"]
    },
    {
      key: "mobExisting",
      title: i18n.global.t("MODULES_EXISTING_MOBILE_NETWORK_STATIONS"),
      description: i18n.global.t("MODULES_EXISTING_MOBILE_NETWORK_STATIONS_DESCRIPTION"),
      urlPath: "mob-existing",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"]
    },
    {
      key: "bctExisting",
      title: i18n.global.t("MODULES_EXISTING_BROADCAST_STATIONS"),
      description: i18n.global.t("MODULES_EXISTING_BROADCAST_STATIONS_DESCRIPTION"),
      urlPath: "bct-existing",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"]
    },
    {
      key: "positionsAndSites",
      title: i18n.global.t("MODULES_POSITIONS_AND_SITES"),
      description: i18n.global.t("MODULES_POSITIONS_AND_SITES_DESCRIPTION"),
      urlPath: "positions-and-sites",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"]
    },
    {
      key: "antennas",
      title: i18n.global.t("MODULES_ANTENNAS"),
      description: i18n.global.t("MODULES_ANTENNAS_DESCRIPTION"),
      urlPath: "antennas",
      accessibleByAdmin: true,
      requlatorAccessValidation: true,
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true,
      route: {
        name: routeNames.antennasMain
      },
      adminPanelRoute: {
        name: routeNames.antennasAdminPanel
      }
    },
    {
      key: "trRxEquipment",
      title: i18n.global.t("MODULES_TX_RX_EQUIPMENT_CONFIGURATION"),
      description: i18n.global.t("MODULES_TX_RX_EQUIPMENT_CONFIGURATION_DESCRIPTION"),
      urlPath: "equipments",
      accessibleByAdmin: true,
      requlatorAccessValidation: true,
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true,
      route: {
        name: routeNames.equipmentsMain
      },
      adminPanelRoute: {
        name: routeNames.equipmentsAdminPanel
      }
    },
    {
      key: "adminSites",
      title: i18n.global.t("MODULES_ADMIN_SITES"),
      description: i18n.global.t("MODULES_ADMIN_SITES_DESCRIPTION"),
      urlPath: "admin-sites",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"]
    },
    {
      key: "agencyControl",
      title: i18n.global.t("MODULES_AGENCY_CONTROL"),
      description: i18n.global.t("MODULES_AGENCY_CONTROL_DESCRIPTION"),
      requiredRoles: ["AGENCE"],
      urlPath: "agency-control",
      v3: true,
      route: {
        name: routeNames.agencyControlMain
      },
      adminPanelRoute: {
        name: routeNames.agencyControlAdminPanel
      }
    },
    {
      key: "restrictedAreas",
      title: i18n.global.t("MODULES_RESTRICTED_AREAS"),
      description: i18n.global.t("MODULES_RESTRICTED_AREAS_DESCRIPTION"),
      urlPath: "restricted-areas",
      v3: true,
      route: {
        name: routeNames.restrictedAreasMain
      },
      adminPanelRoute: {
        name: routeNames.restrictedAreasAdminPanel
      }
    },
    {
      key: "authorizationsAndLicenses",
      title: i18n.global.t("MODULES_AUTHORIZATIONS_AND_LICENSES"),
      description: i18n.global.t("MODULES_AUTHORIZATIONS_AND_LICENSES_DESCRIPTION"),
      urlPath: "authorizations-and-licenses",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true
    },
    {
      key: "fees",
      title: i18n.global.t("MODULES_FEES"),
      description: i18n.global.t("MODULES_FEES_DESCRIPTION"),
      urlPath: "fees",
      requiredOrigins: ["USERS", "USERS_CNTCT"],
      requiredRoles: ["FEE"],
      v3: true,
      route: {
        name: routeNames.feesMain
      },
      adminPanelRoute: {
        name: routeNames.feesAdminPanel
      }
    },
    {
      key: "comsis",
      title: i18n.global.t("MODULES_COMSIS"),
      description: i18n.global.t("MODULES_COMSIS_DESCRIPTION"),
      urlPath: "comsis",
      requiredRequestSystems: ["COM"],
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER"],
      tileLinks: [
        {
          label: i18n.global.t("MODULES_COMSIS_STATIONS_LIST"),
          href: "/frontend/comsis/#/stations-list"
        },
        isUserAdminVisitorOrWatcher
          ? null
          : {
              label: i18n.global.t("MODULES_COMSIS_REQUESTS_LIST"),
              href: "/frontend/comsis/#/requests-list"
            },
        {
          label: i18n.global.t("MODULES_COMSIS_STATIONS_MAP"),
          href: "/frontend/comsis/#/stations-map"
        }
      ].filter((link) => link)
    },
    {
      key: "spectrum",
      title: i18n.global.t("MODULES_SPECTRUM"),
      description: i18n.global.t("MODULES_SPECTRUM_DESCRIPTION"),
      urlPath: "spectrum",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true,
      route: {
        name: routeNames.spectrumMain
      },
      adminPanelRoute: {
        name: routeNames.spectrumAdminPanel
      }
    },
    {
      key: "surveys",
      title: i18n.global.t("MODULES_SURVEYS"),
      description: i18n.global.t("MODULES_SURVEYS_DESCRIPTION"),
      urlPath: "surveys",
      requiresSurveyCheck: true,
      requlatorAccessValidation: true,
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true,
      route: {
        name: routeNames.surveysList
      },
      adminPanelRoute: {
        name: routeNames.surveysAdminPanel
      }
    },
    {
      key: "pmr",
      title: i18n.global.t("MODULES_PMR"),
      description: i18n.global.t("MODULES_PMR_DESCRIPTION"),
      urlPath: "pmr",
      requiredRequestSystems: ["PMR"],
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true,
      route: {
        name: routeNames.pmrMain
      },
      adminPanelRoute: {
        name: routeNames.pmrAdminPanel
      },
      tileLinks: [
        {
          label: i18n.global.t("MODULES_PMR_MAP_VIEW"),
          to: {
            name: routeNames.pmrMain
          }
        },
        {
          label: i18n.global.t("MODULES_PMR_REQUESTS"),
          to: { name: routeNames.pmrRequests }
        }
      ].filter((link) => link)
    },
    {
      key: "otsApplications",
      title: i18n.global.t("MODULES_OTS_APPLICATIONS"),
      description: i18n.global.t("MODULES_OTS_APPLICATIONS_DESCRIPTION"),
      urlPath: "ots-applications",
      requiredRequestSystems: ["TS"],
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"]
    },
    {
      key: "joApplications",
      title: i18n.global.t("MODULES_JO_APPLICATIONS"),
      description: i18n.global.t("MODULES_JO_APPLICATIONS_DESCRIPTION"),
      urlPath: "jo-applications",
      requiredRequestSystems: ["TS"],
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"]
    },
    {
      key: "privateRadioNetwork",
      title: i18n.global.t("MODULES_PRIVATE_RADIO_NETWORK"),
      description: i18n.global.t("MODULES_PRIVATE_RADIO_NETWORK"),
      urlPath: "private-radio-network",
      requiredRequestSystems: ["PMR"],
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"]
    },
    {
      key: "freqExperimentationRequests",
      title: i18n.global.t("MODULES_FREQ_EXPERIMENTATION_REQUESTS"),
      description: i18n.global.t("MODULES_FREQ_EXPERIMENTATION_REQUESTS_DESCRIPTION"),
      urlPath: "freq-experimentation-requests",
      requiredRequestSystems: ["EXP"],
      requiredRoles: ["REGULATOR", "REQUEST", "OWNER"],
      v3: true,
      route: {
        name: routeNames.freqExperimentationRequestsMain
      },
      adminPanelRoute: {
        name: routeNames.freqExperimentationRequestsAdminPanel
      }
    },
    {
      key: "coverageStatistics",
      title: i18n.global.t("MODULES_COVERAGE_STATISTICS"),
      description: i18n.global.t("MODULES_COVERAGE_STATISTICS_DESCRIPTION"),
      urlPath: "coverage-statistics",
      requiredRoles: ["REGULATOR", "OWNER", "REQUEST", "VISITOR", "WATCHER", "PORTADMIN"],
      v3: true,
      route: {
        name: routeNames.coverageStatisticsMain
      },
      adminPanelRoute: {
        name: routeNames.coverageStatisticsAdminPanel
      }
    }
  ]
}

export const getTranslationForModule = (module) => {
  switch (module.id) {
    case "mwApplicationsRequests":
      return i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_MW")
    case "mwParity":
      return i18n.global.t("MODULES_MW_PARITY")
    case "mwExisting":
      return i18n.global.t("MODULES_MW_EXISTING")
    case "mwDeploymentSimulation":
      return i18n.global.t("MODULES_MW_DEPLOYMENT_SIMULATION")
    case "esApplicationsRequests":
      return i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_ES")
    case "antennas":
      return i18n.global.t("MODULES_ANTENNAS")
    case "trRxEquipment":
      return i18n.global.t("MODULES_TX_RX_EQUIPMENT_CONFIGURATION")
    case "adminSites":
      return i18n.global.t("MODULES_ADMIN_SITES")
    case "agencyControl":
      return i18n.global.t("MODULES_AGENCY_CONTROL")
    case "restrictedAreas":
      return i18n.global.t("MODULES_RESTRICTED_AREAS")
    case "freqExperimentationRequests":
      return i18n.global.t("MODULES_FREQ_EXPERIMENTATION_REQUESTS")
    case "fees":
      return i18n.global.t("MODULES_FEES")
    case "comsis":
      return i18n.global.t("MODULES_COMSIS")
    case "surveys":
      return i18n.global.t("MODULES_SURVEYS")
    case "spectrum":
      return i18n.global.t("MODULES_SPECTRUM")
    case "pmr":
      return i18n.global.t("MODULES_PMR")
    case "otsApplications":
      return i18n.global.t("MODULES_OTS_APPLICATIONS")
    case "joApplications":
      return i18n.global.t("MODULES_JO_APPLICATIONS")
    case "privateRadioNetwork":
      return i18n.global.t("MODULES_PRIVATE_RADIO_NETWORK")
    case "bctApplicationsRequests":
      return i18n.global.t("MODULES_APPLICATIONS_AND_REQUESTS_BCT")
    case "authorizationsAndLicenses":
      return i18n.global.t("MODULES_AUTHORIZATIONS_AND_LICENSES")
    case "coverageStatistics":
      return i18n.global.t("MODULES_COVERAGE_STATISTICS")
    default:
      return module.id
  }
}

export const getAvailableLoginPageModules = () => [
  {
    value: "main/#/login/form",
    label: i18n.global.t("ADMIN_PANEL_TAB_LOGIN_PAGE_BUTTONS_MODAL_MODULE_MAIN_LOGIN_FORM"),
    always: true
  },
  {
    value: "mw-parity/#/view",
    label: i18n.global.t("MODULES_MW_PARITY"),
    name: "mwParity"
  },
  {
    value: "spectrum/#/view",
    label: i18n.global.t("MODULES_SPECTRUM"),
    name: "spectrum"
  },
  {
    value: "mw-deployment-simulation/#/simulation",
    label: i18n.global.t("MODULES_MW_DEPLOYMENT_SIMULATION"),
    name: "mwDeploymentSimulation"
  },
  {
    value: "coverage-statistics/#/view",
    label: i18n.global.t("MODULES_COVERAGE_STATISTICS"),
    name: "coverageStatistics"
  }
]

export const redirectable = [
  { id: "modules", name: "modules" },
  { id: "helpPage", name: "helpPage" },
  { id: "documentation", name: "documentation" }
]

export const redirectableModules = [
  { id: "mwApplicationsRequests", name: "mwApplicationsRequests" },
  { id: "mwParity", name: "mwParity" },
  { id: "mwExisting", name: "mwExisting" },
  { id: "mwDeploymentSimulation", name: "mwDeploymentSimulation" },
  { id: "esApplicationsRequests", name: "esApplicationsRequests" },
  { id: "antennas", name: "antennas" },
  { id: "trRxEquipment", name: "trRxEquipment" },
  { id: "adminSites", name: "adminSites" },
  { id: "agencyControl", name: "agencyControl" },
  { id: "restrictedAreas", name: "restrictedAreas" },
  { id: "fees", name: "fees" },
  { id: "comsis", name: "comsis" },
  { id: "surveys", name: "surveys" },
  { id: "pmr", name: "pmr" },
  { id: "otsApplications", name: "otsApplications" },
  { id: "joApplications", name: "joApplications" },
  { id: "privateRadioNetwork", name: "privateRadioNetwork" },
  { id: "coverageStatistics", name: "coverageStatistics" }
]

export const allModules = [
  { id: "mwApplicationsRequests", name: "mwApplicationsRequests" },
  { id: "mwParity", name: "mwParity" },
  { id: "mwExisting", name: "mwExisting" },
  { id: "mwDeploymentSimulation", name: "mwDeploymentSimulation" },
  { id: "esApplicationsRequests", name: "esApplicationsRequests" },
  { id: "antennas", name: "antennas" },
  { id: "trRxEquipment", name: "trRxEquipment" },
  { id: "freqExperimentationRequests", name: "freqExperimentationRequests" },
  { id: "adminSites", name: "adminSites" },
  { id: "agencyControl", name: "agencyControl" },
  { id: "restrictedAreas", name: "restrictedAreas" },
  { id: "fees", name: "fees" },
  { id: "comsis", name: "comsis" },
  { id: "surveys", name: "surveys" },
  { id: "spectrum", name: "spectrum" },
  { id: "pmr", name: "pmr" },
  { id: "otsApplications", name: "otsApplications" },
  { id: "joApplications", name: "joApplications" },
  { id: "privateRadioNetwork", name: "privateRadioNetwork" },
  { id: "bctApplicationsRequests", name: "bctApplicationsRequests" },
  { id: "authorizationsAndLicenses", name: "authorizationsAndLicenses" },
  { id: "coverageStatistics", name: "coverageStatistics" }
]

export const redirectableForAdmin = [
  { id: "modules", name: "modules" },
  { id: "helpPage", name: "helpPage" },
  { id: "modulesSettings", name: "modules", params: { mode: "settings" } },
  { id: "documentation", name: "documentation" }
]

export const getModuleEvents = () => [
  {
    name: "comsis",
    events: [
      {
        name: "stationOpened",
        label: i18n.global.t("STATS_COMSIS_STATION_OPENED"),
        params: [
          {
            name: "stationManager",
            label: i18n.global.t("STATS_COMSIS_STATION_MANAGER")
          },
          {
            name: "stationAnfr",
            label: i18n.global.t("STATS_COMSIS_STATION_ANFR")
          },
          {
            name: "stationName",
            label: i18n.global.t("STATS_COMSIS_STATION_NAME")
          }
        ]
      },
      {
        name: "reportGenerated",
        label: i18n.global.t("STATS_COMSIS_REPORT_GENERATED"),
        params: [
          {
            name: "reportType",
            label: i18n.global.t("STATS_COMSIS_REPORT_TYPE")
          },
          {
            name: "reportName",
            label: i18n.global.t("STATS_COMSIS_REPORT_NAME")
          },
          {
            name: "stationAnfr",
            label: i18n.global.t("STATS_COMSIS_STATION_ANFR")
          },
          {
            name: "stationName",
            label: i18n.global.t("STATS_COMSIS_STATION_NAME")
          }
        ]
      },
      {
        name: "reportPreviewed",
        label: i18n.global.t("STATS_COMSIS_REPORT_PREVIEWED"),
        params: [
          {
            name: "reportName",
            label: i18n.global.t("STATS_COMSIS_REPORT_NAME")
          },
          {
            name: "stationAnfr",
            label: i18n.global.t("STATS_COMSIS_STATION_ANFR")
          },
          {
            name: "stationName",
            label: i18n.global.t("STATS_COMSIS_STATION_NAME")
          }
        ]
      },
      {
        name: "showAllUsed",
        label: i18n.global.t("STATS_COMSIS_SHOW_ALL_USED"),
        params: []
      }
    ]
  }
]

export const getModuleSubheader = (moduleName) => {
  const globalStore = useGlobalStore()
  const sessionStore = useSessionStore()

  if (moduleName === "equipments") {
    const options = []

    if (globalStore.globalConfig.modules.trRxEquipment.existing) {
      options.push({
        label: i18n.global.t("HEADER_EXISTING_EQUIPMENTS"),
        to: {
          name: routeNames.equipmentsMain
        }
      })
    }

    if (globalStore.globalConfig.modules.trRxEquipment.new) {
      options.push({
        label: i18n.global.t("HEADER_NEW_EQUIPMENTS"),
        to: {
          name: routeNames.equipmentsDrafts
        }
      })
    }
    return {
      title: i18n.global.t("HEADER_MODULE_NAME"),
      options
    }
  }

  if (moduleName === "antennas") {
    const options = []

    if (globalStore.globalConfig.modules.antennas.existing) {
      options.push({
        label: i18n.global.t("HEADER_EXISTING_ANTENNAS"),
        to: {
          name: routeNames.antennasMain
        }
      })
    }

    if (globalStore.globalConfig.modules.antennas.new) {
      options.push({
        label: i18n.global.t("HEADER_NEW_ANTENNAS"),
        to: {
          name: routeNames.antennasDrafts
        }
      })
    }
    return {
      title: i18n.global.t("HEADER_MODULE_NAME"),
      options
    }
  }

  if (moduleName === "pmr") {
    const options = []
    if (!sessionStore.isAdmin) {
      options.push({
        label: i18n.global.t("HEADER_MAP_VIEW"),
        to: {
          name: routeNames.pmrMain
        }
      })

      if (sessionStore.isLoggedIn) {
        options.push({
          label: i18n.global.t("HEADER_REQUESTS"),
          to: { name: routeNames.pmrRequests }
        })
      }
    }

    return {
      title: i18n.global.t("HEADER_MODULE_NAME"),
      options
    }
  }

  return null
}
